import React from 'react'
import propTypes from 'prop-types'
import classNames from 'classnames'

import Loader from 'components/Loader'
import Pagination from 'components/Pagination'
import { FaCheck } from 'react-icons/fa'
import FullScreenMessage from 'components/FullScreenMessage'


export default function Grid(props) {
  return (
    <div className={classNames(
      'relative',
      props.className,
    )}>
      <Loader
        active={!!props.loading}
        center
        containerClassName='bg-black bg-opacity-40 z-10'
      />
      {
        React.Children.count(props.children) === 0 ?
        <FullScreenMessage>
          Empty
        </FullScreenMessage> :
        <div className='grid grid-cols-3 gap-1 sm:grid-cols-5 lg:grid-cols-7 2xl:grid-cols-10'>{props.children}</div>
      }
      <Pagination
        className='mt-5'
        {...props.pagination}
      />
    </div>
  )
}

const Item = props => {
  return (
    <div
      className={classNames(
        'relative w-full',
        props.className,
      )}
    >
      {props.children}
      {
        props.canSelect &&
        <div
          className={classNames(
            'absolute left-0 top-0 w-full h-full',
            'cursor-pointer transition-all',
            {'bg-white bg-opacity-60': props.selected },
          )}
          onClick={props.onChange}
        >
          <div
            className={classNames(
              'p-2 w-auto',
              'flex items-center justify-center space-x-2',
              'transition-all',
              'bg-white',
              'hover:shadow-lg',
              'rounded-full left-1 top-1 absolute transform',
              {'shadow-lg text-success-600 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10': props.selected},
              {'bg-opacity-50 text-black': ! props.selected},
            )}
          >
            {
              props.selected &&
              <span className='p-2'>{props.indexSelected + 1}</span>
            }
            <span>
              <FaCheck />
            </span>
          </div>
        </div>
      }
    </div>
  )
}


Grid.propTypes = {
  loading: propTypes.bool,
  pagination: propTypes.shape({
    pages: propTypes.number.isRequired,
    selected: propTypes.number.isRequired,
    onChange: propTypes.func.isRequired,
  }),
  children: propTypes.oneOfType([
    propTypes.shape({
      type: propTypes.oneOf([Item]),
    }),
    propTypes.arrayOf(
      propTypes.shape({
        type: propTypes.oneOf([Item]),
      })
    ),
  ]).isRequired,
}

Item.propTypes = {
  selected: propTypes.bool,
  indexSelected: propTypes.number,
  onChange: propTypes.func,
}

Grid.Item = Item
